import React from 'react';
import useGetRequest from '../../../../hooks/useGetRequest';
import {
  Contact, Task, TriggeredActionDetail
} from '../../../../types';
import CRUDConfigForm from '../../../../components/formik/CRUDConfigForm';
import FormikSelect from '../../../../components/formik/FormikSelect';


const AssignUserHandler = ({
  engagementId,
  triggeredAction,
  onSuccess,
  onDismiss,
  task,
}: {
    engagementId: string,
    triggeredAction: TriggeredActionDetail,
    onSuccess: (message: string) => void,
    onDismiss: () => void,
    task: Task,
}) => {
  const { autoAssignmentPolicy } = triggeredAction.action;
  // @ts-ignore - auto assignment policy will not be none
  const { role, id } = autoAssignmentPolicy;

  const { result: contacts, isLoading: contactsLoading }: { result: Contact[], isLoading: boolean } = useGetRequest({
    url: '/automatic/contacts/',
    initialResult: [],
  });

  const { result: accountId, isLoading: autoAssignmentResultLoading }: { result: string, isLoading: boolean } = useGetRequest({
    url: `/automatic/engagements/${engagementId}/get-auto-assignment-policy-result/${id}/`,
    initialResult: [],
  });

  if (contactsLoading || autoAssignmentResultLoading) return null;

  const fields = [
    {
      name: 'roleAssignments',
      isArray: true,
      isDynamic: true,
      fields: () => [
        {
          name: 'accountId',
          component: () => (
            <FormikSelect
              fullWidth
              id="account-picker"
              label="User"
              name="roleAssignments[0].accountId"
              options={contacts.map((contact) => ({
                label: `${contact.account.firstName} ${contact.account.lastName}`,
                value: contact.account.id,
              }))}
            />
          ),
          defaultValue: accountId,
        },
        {
          name: 'roleId',
          defaultValue: role.id,
          shouldRender: () => false,
        },
      ]
    },
    {
      name: 'completedTaskId',
      defaultValue: task.id,
    }
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/engagements/${engagementId}/role-assignments/`}
      submitMethodOverride="patch"
      initialValuesOverride={{
        roleAssignments: [{
          accountId,
          roleId: role.id,
        }],
        completedTaskId: task.id,
      }}
      onSuccess={() => onSuccess('User assigned.')}
      fieldsConfig={fields}
      includeDeleteButton
    />
  );
};

export default AssignUserHandler;
